import React from "react";
import { AppBar } from "react-admin";
import CustomUserMenu from "./CustomUserMenu";

const UserMenuAppBar = (props) => (
  <AppBar {...props} userMenu={<CustomUserMenu />} />
);
export default UserMenuAppBar;
